import { render, staticRenderFns } from "./funding.vue?vue&type=template&id=5d3f57c0&scoped=true&"
import script from "./funding.vue?vue&type=script&lang=js&"
export * from "./funding.vue?vue&type=script&lang=js&"
import style0 from "./funding.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./funding.vue?vue&type=style&index=1&id=5d3f57c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f57c0",
  null
  
)

export default component.exports